import * as z from 'zod'

import { BaseSchema_Drone as baseSchema } from '@flows/insurance/schemas'

export const schema = z.preprocess((values) => {
  const valuesCopy = { ...(values as Record<string, any>) }

  return { ...valuesCopy }
}, baseSchema)
